var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { reportUrl } from '@tencent/smp-tools';
import { getDeviceStyle } from '../tool/css';
import { getKeyFromUrl } from '../tool/url';
import Platfrom from '../tool/app/common/plat';
import { AppStatus, StatAction, AppDownloadStatus, AppShowStatus, AppReportAction, } from '../common/constants';
import AppDownloader from '../tool/app/app';
import { debugLogger, errorLogger } from '../tool/debug';
var UButton = /** @class */ (function (_super) {
    __extends(UButton, _super);
    function UButton(props) {
        var _this = _super.call(this, props) || this;
        var renderData = window.RENDER_DATA || {};
        var _a = props.ui || {}, _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
        var _d = props || {}, appStatus = _d.appStatus, progress = _d.progress;
        _this.state = {
            data: data,
            stat: props.stat || renderData.stat || '',
            style: getDeviceStyle(style),
            appStatus: appStatus || AppStatus.NOINSTALL,
            progress: progress,
            canClickFlag: true,
            checkCount: 0,
            appStatusHistory: 0,
            statList: [],
            callbackAction: [],
            visiableUsed: false,
        };
        _this.statMap = {};
        return _this;
    }
    UButton.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = nextProps.ui || {}, _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.style, style = _c === void 0 ? {} : _c;
        this.setState({
            data: data,
            style: getDeviceStyle(style),
        });
        // 添加曝光
        this.handleInitAppConfig(nextProps);
    };
    UButton.prototype.handleResize = function () {
        var style = this.props.ui.style;
        var deviceStyle = getDeviceStyle(style);
        this.setState({
            style: deviceStyle,
        });
    };
    UButton.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var app;
            return __generator(this, function (_a) {
                window.addEventListener('resize', this.handleResize.bind(this), false);
                this.handleInitAppConfig(this.props);
                app = this.props.app;
                if (app) {
                    // 检测APP内容
                    debugLogger('---------------------------------------');
                    debugLogger('当前配置APP内容:');
                    debugLogger("\u5305\u540D:".concat(app.packagename));
                    debugLogger("\u4E0B\u8F7D\u5730\u5740:".concat(app.url));
                    debugLogger("\u62C9\u6D3B\u5730\u5740:".concat(app.active));
                    debugLogger("\u62C9\u65B0\u627F\u63A5:".concat(app.originCopyurl));
                    debugLogger("\u526A\u5207\u5730\u5740:".concat(app.copyurl));
                    debugLogger('---------------------------------------');
                }
                this.handleReportScrollAction();
                return [2 /*return*/];
            });
        });
    };
    // 	组件本身有效曝光 -- 曝光到屏幕里面即可
    UButton.prototype.handleMonitorComponentShow = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _j = this.props || {}, stat = _j.stat, _k = _j.ui, ui = _k === void 0 ? {} : _k;
        var needShowScreenTop = Math.abs((_b = (_a = this.compRef) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.y) <
            window.self.innerHeight -
                ((_c = this.compRef) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect().height) / 2;
        var needShowHeight = Math.abs((_e = (_d = this.compRef) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect()) === null || _e === void 0 ? void 0 : _e.y) <
            window.self.innerHeight - 50;
        if (((_g = (_f = this.compRef) === null || _f === void 0 ? void 0 : _f.getBoundingClientRect()) === null || _g === void 0 ? void 0 : _g.y) >= 0 &&
            (needShowScreenTop || needShowHeight)) {
            var subkey = ui.key;
            var isReported = this.statMap["".concat(subkey, "_SHOW")];
            if (!isReported) {
                this.statMap["".concat(subkey, "_SHOW")] = true;
                reportUrl({
                    statUrl: stat || ((_h = window.RENDER_DATA) === null || _h === void 0 ? void 0 : _h.stat),
                    action: 'SHOW',
                    subkey: subkey,
                });
            }
        }
    };
    UButton.prototype.handleReportScrollAction = function () {
        var _this = this;
        this.handleMonitorComponentShow();
        window.addEventListener('scroll', function () {
            _this.handleMonitorComponentShow();
        });
    };
    /**
     * 回调通知
     * @param callbackFnName
     * @param args
     */
    UButton.prototype.handleCallbackNotice = function (callbackFnName, args) {
        return __awaiter(this, void 0, void 0, function () {
            var callbackAction, callbackFn;
            return __generator(this, function (_a) {
                callbackAction = this.state.callbackAction;
                this.setState({
                    callbackAction: [].concat(callbackAction, callbackFnName),
                });
                callbackFn = this.props[callbackFnName];
                callbackFn && callbackFn(args);
                return [2 /*return*/];
            });
        });
    };
    /**
     * 处理异常通知
     */
    UButton.prototype.handleAppNotice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // 获取用户信息
                this.downloader.on('appinfo', function (info) {
                    _this.setState({
                        qt: encodeURIComponent(JSON.stringify(info)),
                    });
                });
                // API异常
                this.downloader.on('apierror', function () {
                    errorLogger('异常:api异常');
                    clearInterval(_this.timer);
                    _this.handleReport({ action: AppReportAction.APP_DOWNLOAD_FAILED });
                    _this.handleCallbackNotice('onAppDownloadError');
                    _this.setState({
                        canClickFlag: true,
                        appStatus: AppStatus.NOINSTALL,
                        appStatusHistory: AppStatus.NOINSTALL,
                    });
                });
                // fix:新闻再次访问的时候，没有调起安装
                this.downloader.on('downloadsucc', function () {
                    _this.setState({
                        canClickFlag: true,
                    });
                });
                // 安装状态判断异常
                this.downloader.on('install_error', function () {
                    clearInterval(_this.timer);
                    _this.handleReport({ action: AppReportAction.INSTALL_FAILED });
                    _this.handleCallbackNotice('onAppInstallFail');
                });
                this.downloader.on('open_error', function () {
                    _this.handleReport({ action: AppReportAction.TRY_OPEN_FAILED });
                    var _a = _this.props, _b = _a.app, app = _b === void 0 ? {} : _b, subkey = _a.subkey;
                    app.openErrorMessage && alert(app.openErrorMessage);
                });
                // 判断安装状态
                this.downloader.on('install', function (message) {
                    clearInterval(_this.timer);
                    // 监听状态
                    if (message) {
                        _this.handleAppInstallEnd();
                    }
                    else {
                        _this.handleAppInstallCancel();
                    }
                });
                // 第三方的下载,点击即可释放
                this.downloader.on('downdone', function (message) {
                    _this.setState({
                        appStatus: AppStatus.NOINSTALL,
                        canClickFlag: true,
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    // 处理app里面内容异常空格等问题
    UButton.prototype.formatAppInfo = function (app) {
        Object.keys(app).map(function (key) {
            if (typeof app[key] === 'string') {
                app[key] = app[key].trim();
            }
        });
    };
    /**
     * 处理应用配置
     * @param props
     */
    UButton.prototype.handleInitAppConfig = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, app, appStatus, isInstalled, needAutoActive;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = props.app, app = _a === void 0 ? {} : _a;
                        if (!app.packagename && !app.url) {
                            return [2 /*return*/, false];
                        }
                        this.buildAppStat(props);
                        // 处理app里面内容异常空格等问题
                        this.formatAppInfo(app);
                        if (this.downloader) {
                            // 已有downloader，将update配置
                            this.downloader = new AppDownloader(app).instance;
                            return [2 /*return*/, false];
                        }
                        this.downloader = new AppDownloader(app).instance;
                        debugLogger('当前下载器:', this.downloader.name);
                        return [4 /*yield*/, this.downloader.ready()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.handleAppNotice()];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.handleCheckAppInstall()];
                    case 3:
                        appStatus = _b.sent();
                        this.handleCallbackNotice('onBtnReady');
                        isInstalled = appStatus === AppStatus.INSTALLED;
                        // 已安装的状态下，无需check自动激活等
                        if (isInstalled) {
                            this.setState({
                                visiableUsed: true,
                            });
                        }
                        needAutoActive = isInstalled && app.autoActive;
                        if (needAutoActive || app.auto) {
                            this.handleClick();
                        }
                        needAutoActive &&
                            this.handleReport({
                                action: AppReportAction.AUTO_ACTIVE,
                            });
                        this.handleReport({
                            action: AppReportAction.APP_SHOW_DOWNLOAD,
                            subkey: appStatus === AppStatus.INSTALLED
                                ? AppShowStatus.INSTALLED
                                : AppShowStatus.NOINSTALL,
                        });
                        return [4 /*yield*/, this.handlePageVisiable()];
                    case 4:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UButton.prototype.buildAppStat = function (props) {
        var _a = props.app, app = _a === void 0 ? {} : _a, subkey = props.subkey;
        var _b = this.state.stat, stat = _b === void 0 ? '' : _b;
        // QB统计串，拼接规则  qbreportstring&${decodeUrlComponent(qbextst)}
        var qbextst = app.qbextst || getKeyFromUrl('qbextst') || '';
        var qbst = app.qbreportstring || getKeyFromUrl('st') || '';
        var stsource = app.stsource || getKeyFromUrl('stsource') || '';
        var sturl = encodeURIComponent(app.sturl || getKeyFromUrl('sturl') || '');
        // 补充内核统计上报 -- 上报的环节(0:下载开始;1:下载结束;2:安装完成)
        app.qbreportstring =
            (app.qbreportstring || qbst || '') +
                (qbextst ? '&' + decodeURIComponent(qbextst) : '');
        app.reportstring = "".concat(stat, "&action=APP_START_DOWNLOAD&subkey=").concat(subkey, "&qbst=").concat(qbst, "&stsource=").concat(stsource, "&sturl=").concat(sturl, "&r=").concat(Date.now());
        app.reportstring1 = "".concat(stat, "&action=APP_FINISH_DOWNLOAD&subkey=").concat(subkey, "&qbst=").concat(qbst, "&stsource=").concat(stsource, "&sturl=").concat(sturl, "&r=").concat(Date.now());
        app.reportstring2 = "".concat(stat, "&action=INSTALL_SUCCESS&subkey=").concat(subkey, "&qbst=").concat(qbst, "&stsource=").concat(stsource, "&sturl=").concat(sturl, "&r=").concat(Date.now());
        // 腾讯新闻上报
        app.xsreporturl = "".concat(stat, "&action=XSREPORT&subkey=").concat(subkey, "&qbst=").concat(qbst, "&stsource=").concat(stsource, "&sturl=").concat(sturl, "&r=").concat(Date.now());
    };
    // 首次切换回来上报安装完成
    UButton.prototype.handlePageVisiable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                document.addEventListener('visibilitychange', function () { return __awaiter(_this, void 0, void 0, function () {
                    var isHidden, _a, appStatus, visiableUsed;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                isHidden = document.hidden;
                                _a = this.state, appStatus = _a.appStatus, visiableUsed = _a.visiableUsed;
                                if (visiableUsed) {
                                    return [2 /*return*/, false];
                                }
                                if (!!isHidden) return [3 /*break*/, 2];
                                this.setState({
                                    canClickFlag: appStatus !== AppStatus.DOWNLOADING,
                                });
                                return [4 /*yield*/, this.handleCheckAppInstall()];
                            case 1:
                                appStatus = _b.sent();
                                if (appStatus === AppStatus.INSTALLED) {
                                    this.setState({
                                        visiableUsed: true,
                                    });
                                    // if (Platfrom.isTV) {
                                    //   return false;
                                    // }
                                    this.handleClick();
                                    this.handleReport({
                                        action: AppReportAction.INSTALL_AUTO_ACTIVE,
                                    });
                                    this.handleCallbackNotice('onAppInstallAutoActive');
                                }
                                _b.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    /**
     * 处理相关统计上报
     * @param param0
     */
    UButton.prototype.handleReport = function (_a) {
        var _b;
        var action = _a.action, subkey = _a.subkey;
        var _c = this.state, _d = _c.stat, stat = _d === void 0 ? '' : _d, _e = _c.qt, qt = _e === void 0 ? '' : _e;
        // app相关信息，获取组件上游传入，或者从url里面获取
        var _f = this.props.app, app = _f === void 0 ? {} : _f;
        stat &&
            reportUrl({
                statUrl: stat || ((_b = window.RENDER_DATA) === null || _b === void 0 ? void 0 : _b.stat),
                action: action,
                subkey: this.props.subkey || subkey || '',
                qbst: app.qbreportstring || getKeyFromUrl('st') || '',
                stsource: app.stsource || getKeyFromUrl('stsource') || '',
                sturl: app.sturl || getKeyFromUrl('sturl') || '',
                qt: qt,
            });
    };
    /**
     * 获取应用信息
     */
    UButton.prototype.getAppStatus = function () {
        var _a = this.state, appStatus = _a.appStatus, progress = _a.progress;
        return {
            appStatus: appStatus,
            progress: progress,
        };
    };
    /**
     * 检测状态，保留当前状态，例如暂停
     */
    UButton.prototype.handleCheckAppInstall = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, appStatus, _c, checkCount, appStatusHistory, _d, app, isInstall, status_1, e_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.state, _b = _a.appStatus, appStatus = _b === void 0 ? AppStatus.NOINSTALL : _b, _c = _a.checkCount, checkCount = _c === void 0 ? 0 : _c, appStatusHistory = _a.appStatusHistory;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 7, , 8]);
                        _d = this.props.app, app = _d === void 0 ? {} : _d;
                        if (!app.mock) return [3 /*break*/, 2];
                        appStatus = appStatus || AppStatus.NOINSTALL;
                        this.setState({
                            appStatus: appStatus,
                            canClickFlag: appStatus !== AppStatus.DOWNLOADING,
                            checkCount: ++checkCount,
                            appStatusHistory: appStatus,
                        });
                        return [3 /*break*/, 6];
                    case 2: return [4 /*yield*/, this.downloader.isInstalled()];
                    case 3:
                        isInstall = _e.sent();
                        appStatus = isInstall ? AppStatus.INSTALLED : AppStatus.NOINSTALL;
                        return [4 /*yield*/, this.downloader.getStatus()];
                    case 4:
                        status_1 = _e.sent();
                        if (!isInstall && status_1 === AppDownloadStatus.TASK_STATUS_PROGRESS) {
                            appStatus = AppStatus.DOWNLOADING;
                        }
                        if (!isInstall && status_1 === AppDownloadStatus.TASK_STATUS_COMPLETED) {
                            appStatus = AppStatus.DOWNLOADED;
                            if (checkCount === 0) {
                                this.handleReport({ action: AppReportAction.APP_DOWNLOAD_ALREADY });
                            }
                        }
                        return [4 /*yield*/, this.setState({
                                appStatus: appStatus,
                            })];
                    case 5:
                        _e.sent();
                        // check是否是取消安装
                        if (appStatusHistory === AppStatus.INSTALLING &&
                            appStatusHistory > appStatus) {
                            this.handleAppInstallCancel();
                        }
                        // check是否是安装完成
                        if (appStatusHistory === AppStatus.INSTALLING &&
                            appStatus === AppStatus.INSTALLED) {
                            this.handleAppInstallEnd();
                        }
                        this.setState({
                            canClickFlag: appStatus !== AppStatus.DOWNLOADING,
                            checkCount: ++checkCount,
                            appStatusHistory: appStatus,
                        });
                        _e.label = 6;
                    case 6: return [2 /*return*/, appStatus];
                    case 7:
                        e_1 = _e.sent();
                        console.log(e_1);
                        return [2 /*return*/, appStatus];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 处理下载中进度
     * @param url
     */
    UButton.prototype.getDownloadProgress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, app;
            var _this = this;
            return __generator(this, function (_b) {
                _a = this.props.app, app = _a === void 0 ? {} : _a;
                // mock情况下
                this.timer = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                    var _a, appStatus, _b, progress;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _a = this.state, appStatus = _a.appStatus, _b = _a.progress, progress = _b === void 0 ? 0 : _b;
                                if (appStatus === AppStatus.DOWNLOAD_PAUSE) {
                                    return [2 /*return*/, false];
                                }
                                if (!(app.mock || this.downloader.name === 'OtherDownloader')) return [3 /*break*/, 1];
                                progress = Number(progress) + parseInt(String(Math.random() * 2), 10);
                                return [3 /*break*/, 3];
                            case 1: return [4 /*yield*/, this.downloader.getProgress()];
                            case 2:
                                progress = _c.sent();
                                _c.label = 3;
                            case 3:
                                this.setState({
                                    progress: isNaN(progress) ? 0 : progress,
                                });
                                this.handleCallbackNotice('onAppDownloadProgress', { progress: progress });
                                if (progress >= 100) {
                                    clearInterval(this.timer);
                                    this.setState({
                                        progress: 100,
                                    });
                                    this.handleCallbackNotice('onAppDownloadProgress', { progress: progress });
                                    this.handleAppDowloadSucc();
                                }
                                return [2 /*return*/];
                        }
                    });
                }); }, 100);
                return [2 /*return*/];
            });
        });
    };
    /**
     * 处理下载成功
     */
    UButton.prototype.handleAppDowloadSucc = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, app;
            return __generator(this, function (_b) {
                _a = this.props.app, app = _a === void 0 ? {} : _a;
                this.setState({
                    appStatus: AppStatus.DOWNLOADED,
                    appStatusHistory: AppStatus.DOWNLOADED,
                });
                this.handleCallbackNotice('onAppDownloadEnd', { status: true });
                if (app.mock) {
                    this.handleMockInstallNext();
                }
                else {
                    // 主动触发调起安装
                    this.handleAppInstall();
                }
                return [2 /*return*/];
            });
        });
    };
    // mock 下载完成后的流程
    UButton.prototype.handleMockInstallNext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.setState({
                    appStatus: AppStatus.DOWNLOADED,
                });
                this.handleCallbackNotice('onAppInstallStart');
                setTimeout(function () {
                    _this.setState({
                        appStatus: AppStatus.INSTALLING,
                    });
                }, 1000);
                setTimeout(function () {
                    _this.setState({
                        appStatus: AppStatus.INSTALLED,
                    });
                    _this.handleCallbackNotice('onAppInstallEnd');
                }, 2000);
                return [2 /*return*/];
            });
        });
    };
    /**
     * 处理应用下载
     */
    UButton.prototype.handleAppDownload = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, app, _b, canClickFlag, progress, downloadStatus;
            return __generator(this, function (_c) {
                _a = this.props.app, app = _a === void 0 ? {} : _a;
                _b = this.state, canClickFlag = _b.canClickFlag, progress = _b.progress;
                if (!canClickFlag) {
                    return [2 /*return*/, false];
                }
                console.log('handleAppDownload', canClickFlag, progress);
                downloadStatus = AppStatus.DOWNLOADING;
                console.log('handleAppDownload', app.confirmFlag, app.confirmText);
                if (app.confirmFlag &&
                    app.confirmText &&
                    !window.confirm(app.confirmText)) {
                    return [2 /*return*/, false];
                }
                if (!app.mock) {
                    // TBS等其他走API
                    if (progress) {
                        this.downloader.resume();
                    }
                    else {
                        this.handleReport({ action: AppReportAction.APP_CLICK_DOWNLOAD });
                        this.downloader.start();
                    }
                }
                // 传递
                this.handleCallbackNotice('onAppDownloadStart');
                if (progress) {
                    this.handleReport({ action: AppReportAction.APP_DOWNLOAD_RESUME });
                }
                this.setState({
                    canClickFlag: downloadStatus !== AppStatus.DOWNLOADING,
                    appStatus: downloadStatus,
                    appStatusHistory: downloadStatus,
                });
                this.getDownloadProgress();
                return [2 /*return*/];
            });
        });
    };
    /**
     * 处理暂停逻辑
     */
    UButton.prototype.handleAppPause = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, app;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props.app, app = _a === void 0 ? {} : _a;
                        if (!app.canpause) {
                            return [2 /*return*/, false];
                        }
                        clearInterval(this.timer);
                        this.downloader.pause();
                        return [4 /*yield*/, this.setState({
                                appStatus: AppStatus.DOWNLOAD_PAUSE,
                                appStatusHistory: AppStatus.DOWNLOAD_PAUSE,
                                canClickFlag: true,
                            })];
                    case 1:
                        _b.sent();
                        this.handleCallbackNotice('onAppDownloadPause');
                        this.handleReport({ action: AppReportAction.APP_PAUSE_DOWNLOAD });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 应用安装
     */
    UButton.prototype.handleAppInstall = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.handleCallbackNotice('onAppInstallStart');
                this.setState({
                    canClickFlag: true,
                    appStatus: AppStatus.INSTALLING,
                    appStatusHistory: AppStatus.INSTALLING,
                });
                // QB会在内核上报
                if (!Platfrom.isQB) {
                    this.handleReport({ action: AppReportAction.INSTALL_START });
                }
                this.handleAppInstallCheck();
                return [2 /*return*/];
            });
        });
    };
    /**
     * 主动调起安装
     */
    UButton.prototype.handleAppInstallByClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.downloader.install();
                this.handleAppInstall();
                return [2 /*return*/];
            });
        });
    };
    /**
     * 应用检测
     */
    UButton.prototype.handleAppInstallCheck = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timeCount, timer;
            var _this = this;
            return __generator(this, function (_a) {
                timeCount = 0;
                timer = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                    var isInstall;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                timeCount++;
                                return [4 /*yield*/, this.downloader.isInstalled()];
                            case 1:
                                isInstall = _a.sent();
                                if (isInstall) {
                                    this.setState({
                                        appStatus: AppStatus.INSTALLED,
                                        appStatusHistory: AppStatus.INSTALLED,
                                        canClickFlag: true,
                                    });
                                    this.handleAppInstallEnd();
                                    clearInterval(timer);
                                }
                                if (timeCount > 10) {
                                    clearInterval(timer);
                                }
                                return [2 /*return*/];
                        }
                    });
                }); }, 1000);
                return [2 /*return*/];
            });
        });
    };
    /**
     * 安装处理
     *  check 是否已经report
     *  设置自动打开
     */
    UButton.prototype.handleAppInstallEnd = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, autoOpen, callbackAction;
            return __generator(this, function (_b) {
                _a = this.props.app.autoOpen, autoOpen = _a === void 0 ? true : _a;
                callbackAction = this.state.callbackAction;
                if (!callbackAction.includes('onAppInstallEnd')) {
                    this.handleReport({ action: AppReportAction.INSTALL_END });
                    this.handleCallbackNotice('onAppInstallEnd');
                }
                // 默认自动打开
                autoOpen && this.handleAppOpen();
                return [2 /*return*/];
            });
        });
    };
    /**
     * 安装取消
     */
    UButton.prototype.handleAppInstallCancel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var callbackAction;
            return __generator(this, function (_a) {
                callbackAction = this.state.callbackAction;
                if (!callbackAction.includes('onAppInstallCancel')) {
                    this.handleReport({ action: AppReportAction.INSTALL_CANCEL });
                    this.handleCallbackNotice('onAppInstallCancel');
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * 应用打开
     */
    UButton.prototype.handleAppOpen = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.handleCallbackNotice('onAppOpen');
                this.handleReport({ action: AppReportAction.APP_OPEN });
                this.downloader.open();
                return [2 /*return*/];
            });
        });
    };
    /**
     * 处理应用相关逻辑
     */
    UButton.prototype.handleAppClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            var appStatus, canClickFlag;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appStatus = this.state.appStatus;
                        // 点击暂停 -- 只有下载中可暂停
                        if (appStatus === AppStatus.DOWNLOADING) {
                            return [2 /*return*/, this.handleAppPause()];
                        }
                        canClickFlag = this.state.canClickFlag;
                        if (!canClickFlag) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.handleCheckAppInstall()];
                    case 1:
                        // check应用状态
                        appStatus = _a.sent();
                        debugLogger('点击当前状态', appStatus);
                        if (![
                            AppStatus.NOINSTALL,
                            AppStatus.DOWNLOAD_PAUSE,
                            AppStatus.DOWNLOAD_FAIL,
                        ].includes(appStatus)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.handleAppDownload()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        if (!(appStatus === AppStatus.DOWNLOADED)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.handleAppInstallByClick()];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5:
                        if (!(appStatus === AppStatus.INSTALLED)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.handleAppOpen()];
                    case 6: return [2 /*return*/, _a.sent()];
                    case 7: return [4 /*yield*/, this.handleAppDownload()];
                    case 8: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UButton.prototype.handleComponentReport = function (action) {
        var _a;
        var data = this.state.data;
        var _b = this.props, stat = _b.stat, subkey = _b.subkey, _c = _b.ui, ui = _c === void 0 ? { key: 'UButton' } : _c;
        stat &&
            reportUrl({
                statUrl: stat || ((_a = window.RENDER_DATA) === null || _a === void 0 ? void 0 : _a.stat),
                action: action,
                subkey: data.id ? "c_".concat(data.id) : subkey || ui.key || 'UButton',
            });
    };
    /**
     * 点击下载
     */
    UButton.prototype.handleClick = function (e) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, app, onClick;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        e === null || e === void 0 ? void 0 : e.stopPropagation();
                        (_a = e === null || e === void 0 ? void 0 : e.nativeEvent) === null || _a === void 0 ? void 0 : _a.stopImmediatePropagation();
                        this.handleCallbackNotice('onBtnClick');
                        this.handleComponentReport(StatAction.COMPONENT_CLICK);
                        _b = this.props.app, app = _b === void 0 ? {} : _b;
                        if (!(app.packagename || app.url)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.handleAppClick()];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        onClick = this.props.onClick;
                        onClick && onClick();
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return UButton;
}(React.PureComponent));
export default UButton;
